let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9LqSU")).then(() => parcelRequire('TOAHd'));